// extracted by mini-css-extract-plugin
export default {"circularLoader":"loader_circularLoader__eu7SB","rotate4":"loader_rotate4__S6J6D","circularLoaderCircle":"loader_circularLoaderCircle__bma9e","dash4":"loader_dash4__pclz0"};